import jQuery from 'jquery';
window.$ = jQuery;
jQuery(function() {

    //ESTA FUNCION LLAMA A LA REDIRECCION DE CREACION DE NUEVA TIENDA
    $("#nuevatiendabutton").on('click', function() {
        window.location.href = urlnuevatienda;
    });
    
       window.openReviewsModal = (mercadoId) => {

    const container = document.getElementById('reviews-list-tienda');

    container.innerHTML = '<p class="text-center text-gray-500 mt-6">Cargando reseñas...</p>';
    $('#modalReviewsTienda').show();

    fetch(`/mercados/${mercadoId}/reviews`)
        .then(res => res.json())
        .then(data => {
            container.innerHTML = data.html;

            if (window.Alpine) {
                Alpine.flushAndStopDeferringMutations();
                Alpine.initTree(container);
            }
        })
        .catch(() => {
            container.innerHTML = '<p class="text-center text-red-500 mt-6">Error al cargar reseñas.</p>';
        });
};

window.cargarTiendasCategoria = (genero_id, nombre_categoria, plaza_id) => {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    $.ajax({
        type: 'GET',
        url: '/cargarTiendaCategoria',
        data: {genero_id: genero_id,
                 plaza_id: plaza_id
        },
        dataType: 'json',
        success: function(response) {
        if (response.success) {
            if(response.data.length > 0){
        
                
                $('#content-tienda-categoria').empty();
                response.data.forEach(tienda => {
                    const card = crearTarjetaTienda(tienda);
                    document.getElementById("content-tienda-categoria").appendChild(card);
                });
            }else{
                $('#content-tienda-categoria').empty();
                 $('#content-subcategoria-producto').append('No hay tiendas en esta categoria');
            }
        } else {
            alert(response.message);
        }
    },
    error: function() {
        alert('Ocurrió un error al cargar los productos.');
    }
    });

}
});

function crearSVG(paths, viewBox, title) {
    const svgNS = "http://www.w3.org/2000/svg";
    const svg = document.createElementNS(svgNS, "svg");
    svg.setAttribute("class", "w-9 h-9");
    svg.setAttribute("viewBox", viewBox);

    paths.forEach(pathD => {
        const path = document.createElementNS(svgNS, "path");
        path.setAttribute("d", pathD);
        svg.appendChild(path);
    });

    const wrapper = document.createElement("div");
    wrapper.title = title;
    wrapper.appendChild(svg);

    return wrapper;
}

document.addEventListener("DOMContentLoaded", function () {
    toggleInit('texto-mercado', 'toggle-btn-descripcion-tienda');
});

window.toggleTexto = (textId, btnId, limite = 400)=> {
      const p = document.getElementById(textId);
    const btn = document.getElementById(btnId);

    if (!p.dataset.full) {
        const textoCompleto = p?.innerHTML.trim();

        if (textoCompleto.length <= limite) {
            btn.style.display = "none";
            return;
        }

        const textoCorto = textoCompleto.substring(0, limite) + "...";

        p.dataset.full = textoCompleto;
        p.dataset.short = textoCorto;
        p.innerHTML = textoCorto;
    }

    if (p.innerHTML === p.dataset.short) {
        p.innerHTML = p.dataset.full;
        btn.textContent = "Mostrar menos";
    } else {
        p.innerHTML = p.dataset.short;
        btn.textContent = "Mostrar más";
    }
}

function toggleInit(textId, btnId, limite = 400) {
  const p = document.getElementById(textId);
  const btn = document.getElementById(btnId);

  if (!p) return;

  const textoCompleto = (p.innerHTML ?? "").trim();

  if (!btn) {
    if (textoCompleto.length > limite) {
      p.innerHTML = textoCompleto.substring(0, limite) + "...";
    }
    return;
  }

  if (textoCompleto.length <= limite) {
    btn.style.display = "none";
    return;
  }

  p.dataset.full = textoCompleto;
  p.dataset.short = textoCompleto.substring(0, limite) + "...";
  p.innerHTML = p.dataset.short;
}


function crearTarjetaTienda(tienda) {
    const card = document.createElement("div");
    card.className = "card-producto";

    const titulo = document.createElement("div");
    titulo.className = "titulo-card-producto";
    const pTitulo = document.createElement("p");
    pTitulo.textContent = tienda.tipo_genero.split(";")[0];
    titulo.appendChild(pTitulo);
    card.appendChild(titulo);

    const enlace = document.createElement("a");
    enlace.href = `/tienda/${tienda.slug ?? tienda.id}`;

    const imgWrapper = document.createElement("div");
    imgWrapper.className = "img-card-producto";
    const img = document.createElement("img");
    const nombreImg = (tienda.imagenes || '').split(',')[0].trim();
    img.src = nombreImg
        ? window.location.origin + '/storage/uploads/' + nombreImg.replace(/\.webp$/i, '_thumb.webp')
        : '/images/store_no_image.jpg';
    img.alt = tienda.nombre_publico_tienda;
    img.className = "h-full w-full object-cover object-center lg:h-full lg:w-full max-h-[115px]";
    imgWrapper.appendChild(img);
    enlace.appendChild(imgWrapper);

    const nombreTienda = document.createElement("div");
    nombreTienda.className = "nombre-tarjeta";
    nombreTienda.textContent = tienda.nombre_publico_tienda;
    enlace.appendChild(nombreTienda);

    const descripcion = document.createElement("div");
    descripcion.className = "descripcion-card-producto";
    descripcion.innerHTML = `
        <p>${tienda.localidad_tienda}</p>
        <p>${tienda.direccion_descriptiva}</p>
    `;
    enlace.appendChild(descripcion);


    const iconosWrapper = document.createElement("div");
    iconosWrapper.className = "flex justify-center";

    const btn = document.createElement('a');
        btn.href = `/tienda/${tienda.slug ?? tienda.id}`;
        btn.className = `
            mt-auto mx-auto text-white text-center py-2 rounded-lg font-medium transition
            boton-caja w-[190px] bg-coral-600 hover:bg-coral-700 text-white font-semibold py-2 px-4 rounded block
        `;
    btn.innerText ='Ver tienda';
    

    enlace.appendChild(iconosWrapper);
    enlace.appendChild(btn);
    card.appendChild(enlace);
    return card;
}
